import template from './sw-cms-block-image-highlight-row.html.twig';
import './sw-cms-block-image-highlight-row.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
